<template>

<div class="page">
  <DemoMast :imgName="meta.imgName">
    <template v-slot:title>{{meta.title}}</template>
    <template v-slot:copy>
      <div v-html="meta.description" />
    </template>
    <template v-slot:copy-sub>
      <div v-html="meta.descriptionSub" />
    </template>
  </DemoMast>
  <DemoBody v-if="!result">
    <DemoTitle>
      <template v-slot:title>
        {{meta.uploadTitle}}
      </template>
      <template v-slot:copy>
        {{meta.uploadCopy}}
      </template>
    </DemoTitle>
    <DemoImageUploader
      :error="error"
      v-on:selectSample="openSample"
      v-on:clearError="clearError"
      v-on:load="setLoad"
      v-on:unload="setUnload"
      v-on:imageLoaded="onImageLoaded"
      v-on:error="setError"
    />
  </DemoBody>
  <DeepTaggingResult
    v-else
    v-on:reset="result = false"
    v-on:setSampleImage="setSampleImage"
    :sampleImages="sampleImages || []"
    :imageUrl="imageUrl"
    :result="result"
  />
  <SquareLoader v-if="isLoading" />
  <DemoSampleImageSelector
    v-if="isSelectingSample"
    v-on:set="setSampleImage"
    v-on:close="closeSample"
    :images="sampleImages || []"
  />
</div>

</template>

<script>
import DemoView from '../DemoView'
import DeepTaggingResult from './DeepTaggingResult'

export default {
  data() {
    return {
      sampleImages: [
        'deeptagging/sample_deeptagging_1.png',
        'deeptagging/sample_deeptagging_2.png',
        'deeptagging/sample_deeptagging_3.png',
        'deeptagging/sample_deeptagging_4.png',
        'deeptagging/sample_deeptagging_5.png',
        'deeptagging/sample_deeptagging_6.png',
        'deeptagging/sample_deeptagging_7.png',
        'deeptagging/sample_deeptagging_8.png',
        'deeptagging/sample_deeptagging_9.png',
      ],
      tagKey: "base_tags"
    }
  },
  beforeRouteLeave() {
    if (this.result && window.popStateDetected) {
      this.result = false
      window.popStateDetected = false
      return false
    }
  },
  methods: {

  },
  extends: DemoView,
  components: {
    DeepTaggingResult
  }
}

</script>